const greetingScreenButtonPosition = () => {
    const buttonWrapper = document.querySelector('.Greeting-screen__button-wr.--For-mobile');

    if (buttonWrapper) {
        const button = buttonWrapper.querySelector('.Btn');
        if (button) {
            const buttonHeight = button.offsetHeight;
            buttonWrapper.style.height = `${buttonHeight / 2}px`;
        }
    }
};

export default greetingScreenButtonPosition;
